import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2025SGM() {
  return <CategoryPage category="anexo30Y31Ano2025SGM" pageTitle="Sistema de Gestión de Medición 2025" />;
}

export default Anexo30Y31Ano2025SGM;
